const addT2sScript = (onload: () => void): void => {
  const t2sScript = document.createElement("script");

  t2sScript.id = "t2sScript";
  t2sScript.type = "text/javascript";
  t2sScript.async = true;
  t2sScript.onload = onload;
  t2sScript.src =
    ("https:" === document.location.protocol ? "https" : "http") +
    "://static.target2sell.com/t2s.min.js";

  document.body.append(t2sScript);
};

export default addT2sScript;
